/**
 * AdminImports — Settings → Imports tab. Inner sub-tabs to import Students or Teachers.
 */
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { GraduationCap, Users } from "lucide-react";
import AdminStudents from "@/pages/AdminStudents";
import TeacherImportPanel from "@/pages/TeacherImportPanel";

export default function AdminImports() {
  const [params] = useSearchParams();
  const initial = params.get("sub") === "teachers" ? "teachers" : "students";
  const [sub, setSub] = useState(initial);
  return (
    <div data-testid="admin-imports">
      <Tabs value={sub} onValueChange={setSub}>
        <TabsList className="bg-slate-100 dark:bg-slate-800/60" data-testid="imports-subtabs">
          <TabsTrigger value="students" data-testid="imports-tab-students" className="gap-1.5">
            <GraduationCap className="h-4 w-4" /> Students
          </TabsTrigger>
          <TabsTrigger value="teachers" data-testid="imports-tab-teachers" className="gap-1.5">
            <Users className="h-4 w-4" /> Teachers
          </TabsTrigger>
        </TabsList>
        <TabsContent value="students" className="mt-6"><AdminStudents embedded /></TabsContent>
        <TabsContent value="teachers" className="mt-6"><TeacherImportPanel /></TabsContent>
      </Tabs>
    </div>
  );
}
